{
  "version": 1,
  "asset_id": "75020630-4a0e-4352-9ce8-de6a8a92db23",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/75020630-4a0e-4352-9ce8-de6a8a92db23/airtechpro-gsc-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/75020630-4a0e-4352-9ce8-de6a8a92db23/airtechpro-gsc-640.avif",
  "original_filename": "airtechpro-gsc-640.avif",
  "size": 11012,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:16Z"
}
